const uniqueKeys = keys => Array.from(new Set(keys.filter(Boolean)))

export function getNextPlaylistTrack(playlistItems, currentMediaKey, options = {}) {
    const playlist = (playlistItems || []).filter(item => item?.mediaKey)
    const playlistKeys = playlist.map(item => item.mediaKey)
    const playlistKeySet = new Set(playlistKeys)
    const currentIndex = playlistKeys.indexOf(currentMediaKey)
    const { loop = false, shuffle = false, playedKeys = [], random = null } = options

    if (!playlist.length) {
        return { track: null, playedKeys: [] }
    }

    const sanitizedPlayedKeys = (playedKeys || []).filter(key => playlistKeySet.has(key))
    if (!shuffle) {
        if (currentIndex < 0) {
            return { track: playlist[0] || null, playedKeys: sanitizedPlayedKeys }
        }

        return {
            track: playlist[currentIndex + 1] || (loop ? playlist[0] || null : null),
            playedKeys: sanitizedPlayedKeys,
        }
    }

    const currentKey = currentIndex >= 0 ? playlistKeys[currentIndex] : null
    let nextPlayedKeys = sanitizedPlayedKeys
    if (currentKey && !nextPlayedKeys.includes(currentKey)) {
        nextPlayedKeys = [...nextPlayedKeys, currentKey]
    }

    let candidates = playlist.filter(item => !nextPlayedKeys.includes(item.mediaKey))
    if (!candidates.length) {
        if (!loop) {
            return { track: null, playedKeys: nextPlayedKeys }
        }

        nextPlayedKeys = currentKey ? [currentKey] : []
        candidates = playlist.filter(item => item.mediaKey !== currentKey)
        if (!candidates.length) {
            candidates = playlist
        }
    }

    const candidateIndex =
        typeof random === 'function' ? Math.floor(random() * candidates.length) : 0
    const track = candidates[candidateIndex] || null

    return {
        track,
        playedKeys: track
            ? uniqueKeys([...nextPlayedKeys, track.mediaKey]).filter(key => playlistKeySet.has(key))
            : nextPlayedKeys,
    }
}

export function getPreviousHistoryTrack(historyItems, currentMediaKey, options = {}) {
    const history = (historyItems || []).filter(item => item?.mediaKey)
    if (!currentMediaKey || !history.length) return null

    const getTrack =
        typeof options.getTrack === 'function'
            ? options.getTrack
            : mediaKey => history.find(item => item.mediaKey === mediaKey) || null
    const navQueue = Array.isArray(options.navQueue) ? options.navQueue : null

    if (navQueue?.length) {
        const queueIndex = navQueue.indexOf(currentMediaKey)
        if (queueIndex >= 0) {
            return getTrack(navQueue[queueIndex + 1]) || null
        }
    }

    const historyIndex = history.findIndex(item => item.mediaKey === currentMediaKey)
    return historyIndex >= 0 ? history[historyIndex + 1] || null : null
}
